import { Axios } from "../utils";
import { getSangjoQuotationStatus } from "../constants/quotation";

export interface SangjoQuotationRequestBody {
  status: string;
  funeral_sido: string; // 고이 지역 코드(raw 문자열, KOSIS 아님). 예: "11"
  funeral_sigungu: string; // 예: "11240"
  needs_binso: boolean;
  condolers: string;
}

// 익명 게스트 견적 생성. 백엔드 create=AllowAny, user=null 허용.
// 반환된 id를 로그인 리다이렉트에 qid로 실어 platform에서 유저에 바인딩.
export const postSangjoQuotationRequest = (body: SangjoQuotationRequestBody) =>
  Axios.post("/sangjo_quotation_requests/", {
    ...body,
    status: getSangjoQuotationStatus(body.status),
  });

/**
 * 견적 memo 부기(출처 표기). 상담원이 어드민에서 어느 포털·장례식장에서 온 견적인지 보게 한다.
 *
 * 미바인딩(user=null) 견적은 익명 PATCH가 열려 있다.
 *   apps/consult/views/quotation.py:34
 *   IsOwner.has_object_permission: if obj.user: return obj.user == request.user / return True
 * platform의 비로그인 parlor-requests 제출도 같은 경로를 쓴다.
 *
 * create body에 memo를 넣는 방식은 불가하다. CreateSerializer.Meta.fields에 memo가 없어
 * 에러 없이 조용히 버려진다. 로그인 body의 memo도 안 된다. 그건 슬랙 알림 텍스트로만 쓰이고
 * DB에 저장되지 않는다(apps/user/views/user.py:341 → send_login_notification/send_signup_notification).
 *
 * 파이프 금지: UpdateSerializer.update가 memo.partition("|")[-1]을 상조사 채널에
 * "요청사항 도착" 알림으로 보낸다. 출처 표기가 파트너에게 나가면 안 되니 여기서 제거한다.
 */
export const patchSangjoQuotationMemo = (id: number, memo: string) =>
  Axios.patch(`/sangjo_quotation_requests/${id}/`, {
    memo: memo.replace(/\|/g, " ").slice(0, 255), // memo는 CharField(max_length=255)
  });
